enum SentreeSteadyStateSubEventTypes {
    steady = 'ON - Steady',
    unsteady = 'ON - Unsteady',
    off = 'OFF',
};
export default SentreeSteadyStateSubEventTypes;